(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5952],{

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 92304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/components/footer/index.tsx
var footer = __webpack_require__(56582);
// EXTERNAL MODULE: ./src/components/campus/index.module.scss
var index_module = __webpack_require__(34769);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/utils/hooks/useScroll.tsx


var UseScroll = function UseScroll() {
  var _useState = (0,react.useState)(0),
      scrollTop = _useState[0],
      setScrollTop = _useState[1];

  var onScroll = (0,react.useCallback)(function () {
    setScrollTop(document.documentElement.scrollTop);
  }, []);
  (0,react.useEffect)(function () {
    window.addEventListener('scroll', onScroll, false);
    return function () {
      return window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);
  return scrollTop;
};

/* harmony default export */ var useScroll = (UseScroll);
// EXTERNAL MODULE: ./src/components/openApp/index.module.scss
var openApp_index_module = __webpack_require__(78722);
var openApp_index_module_default = /*#__PURE__*/__webpack_require__.n(openApp_index_module);
// EXTERNAL MODULE: ./src/utils/store.ts
var utils_store = __webpack_require__(50589);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(25427);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/openApp/index.tsx









var OpenApp = function OpenApp() {
  var _useState = (0,react.useState)(false),
      showApp = _useState[0],
      setShowApp = _useState[1];

  (0,react.useEffect)(function () {
    var isPhone = (0,utils/* isMobile */.tq)();
    var store = (0,utils_store/* default */.Z)();

    if (isPhone) {
      var userAgent = navigator.userAgent;

      if (userAgent.indexOf('XYLINK') >= 0) {
        setShowApp(false);
        return;
      }

      if (store.get('isCloseScanner') * 1 === 1) {
        var startTime = store.get('startTime') * 1;

        if (new Date().getTime() - startTime > 24 * 3600 * 1000) {
          setShowApp(true);
          store.set('isCloseScanner', 0); // 可有可无

          store.set('startTime', new Date().getTime());
        }
      } else {
        setShowApp(true);
        store.set('isCloseScanner', 0);
      }
    }
  }, []);

  var openApp = function openApp() {
    var openHash;
    var plat = (0,utils/* platform */.Jv)();

    var _window = window,
        _window$_hmt = _window._hmt,
        _hmt = _window$_hmt === void 0 ? [] : _window$_hmt;

    if (plat.weixin) {
      if (plat.ios) {
        openHash = 'ios-wx';

        _hmt.push(['_trackEvent', '狰', 'weixindakaiApple']);

        _hmt.push(['_trackEvent', '狰', '微信打开iOS']);
      } else {
        openHash = 'android-wx';

        _hmt.push(['_trackEvent', '政', '微信打开Android']);
      }
    } else {
      if (plat.ios) {
        openHash = 'ios-browser';

        _hmt.push(['_trackEvent', '狰', '浏览器打开iOS']);
      } else {
        openHash = 'android-browser';

        _hmt.push(['_trackEvent', '政', '浏览器打开Android']);
      }
    }

    window.location.href = '/download?source=' + openHash;
  };

  var deleteApp = function deleteApp() {
    setShowApp(false);
    var store = (0,utils_store/* default */.Z)();
    store.set('isCloseScanner', 1);
    store.set('startTime', new Date().getTime());
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((openApp_index_module_default())["mob-only-item"], (openApp_index_module_default())["download-app-tips"], !showApp && (openApp_index_module_default()).hide),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (openApp_index_module_default()).left,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        className: (openApp_index_module_default())["btn-delete"],
        onClick: deleteApp,
        src: "/v2/images/header/delete.png",
        width: 36,
        height: 36,
        alt: "delete"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        className: (openApp_index_module_default())["icon-xiaoyu"],
        src: "/v2/images/header/xiaoyu.png",
        width: 54,
        height: 54,
        alt: "xiaoyu"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (openApp_index_module_default())["main-title"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (openApp_index_module_default())["header-title"],
          children: "\u5C0F\u9C7C\u6613\u8FDEAPP"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (openApp_index_module_default())["header-desc"],
          children: "\u8BA9\u4E16\u754C\u96F6\u8DDD\u79BB"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (openApp_index_module_default()).right,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (openApp_index_module_default())["open-app"],
        onClick: openApp,
        children: "\u7ACB\u5373\u6253\u5F00"
      })
    })]
  });
};

/* harmony default export */ var openApp = (OpenApp);
;// CONCATENATED MODULE: ./src/components/campus/layout.tsx












var navbar = [{
  key: 'home',
  title: '首页',
  url: '/campus2022'
}, {
  key: 'position',
  title: '职位',
  url: '/campus2022/position'
}];

var Layout = function Layout(prop) {
  var pageKey = prop.pageKey,
      children = prop.children;
  var scrollTop = useScroll();

  var goTo = function goTo(url) {
    router_default().push(url);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        href: "/v2/favicon.ico"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "\u5C0F\u9C7C\u6613\u8FDE2022\u79CB\u5B63\u6821\u56ED\u62DB\u8058-\u86DF\u9F99\u8BA1\u5212"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      className: (index_module_default()).header,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(openApp, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).container,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: constants/* homeUrl */.hB,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/v2/images/login-logo.png",
            alt: "logo",
            width: "134",
            height: "28"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((index_module_default()).place, 'for-mobile')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).banner
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default())["nav-parent"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((index_module_default()).navbar, scrollTop > 458 && (index_module_default()).fixed),
        children: navbar.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()((index_module_default()).navItem, pageKey === item.key && (index_module_default()).focus),
            onClick: function onClick() {
              return goTo(item.url);
            },
            children: item.title
          }, item.key);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(footer/* default */.Z, {})]
  });
};

/* harmony default export */ var layout = (Layout);

/***/ }),

/***/ 16267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_lib_carousel_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79445);
/* harmony import */ var antd_lib_carousel_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_carousel_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_carousel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41240);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_campus_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92304);
/* harmony import */ var styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70036);
/* harmony import */ var styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94142);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var IMG_PATH = 'https://devcdn.xylink.com/xylink_website_doc/images';
var environmentList = [{
  img: '/campus/pc/site-beijing2022.jpg',
  title: '北京'
}, {
  img: '/campus/pc/site-wuhan2022.jpg',
  title: '武汉'
}, {
  img: '/campus/pc/site-xian2022.jpg',
  title: '西安'
}, {
  img: '/campus/pc/site-zhengzhou2022.jpg',
  title: '郑州'
}, {
  img: '/campus/pc/site-shenzhen2022.jpg',
  title: '深圳'
}, {
  img: '/campus/pc/site-chengdu2022.jpg',
  title: '成都'
}];
var seniorList = [{
  img: '/campus/pc/senior_ZhouPeng.png',
  name: '周鹏-蛟龙一期',
  from: '西华大学19届\r\r软件工程专业',
  position: '研发部\r\r技术骨干',
  sendWord: '小鱼是一个充满活力、积极向上的团队。这里有着世界最前沿的音视频技术，有着与你共同快速成长的优秀伙伴，有着勇攀高峰和精益求精的精神，欢迎大家加入小鱼，成就更好的自己！'
}, {
  img: '/campus/pc/senior_NieHaiqing.png',
  name: '聂海情-蛟龙一期',
  from: '华北电力大学19届\r\r电子信息科学与技术 ',
  position: '测试部\r\r测试骨干',
  sendWord: '小鱼是一个开放自由的平台，这里有一对一的导师悉心指导，助你上好“职场第一课”；这里有并肩作战的兄弟，一同砥砺前进，披荆斩棘；金麟岂是池中物，一遇风云便化龙，加入我们一起共创精彩！'
}, {
  img: '/campus/pc/senior_GuoShihao.png',
  name: '郭世豪-蛟龙二期',
  from: '华北科技学院20届\r\r电子信息工程专业',
  position: '技术架构部\r\r架构师',
  sendWord: '工作中前辈们的淳淳教导，同事间的相互鼓励，以及丰富的团建娱乐，打破了我对职场固有的认知，原来工作也可以这么有趣！非常荣幸成为小鱼大家庭中的一员，欢迎加入我们！'
}, {
  img: '/campus/pc/senior_Wangjin.png',
  name: '王锦-蛟龙二期',
  from: '西安财经大学20届\r\r计算机科学与技术专业',
  position: '研发部\r\r研发工程师',
  sendWord: '小鱼是一个拥有独特风格和企业文化的公司，团队氛围很好，员工对自己负责的业务尽职尽责。团队分工明确，对于技术问题充满好奇心，好奇心才会让小鱼走的更高、更远。很荣幸成为“小鱼人”。'
}, {
  img: '/campus/pc/senior_WuYitong.png',
  name: '武一彤-蛟龙三期',
  from: '西南交通大学21届\r\r统计学专业',
  position: '营销部\r\r销售管培生',
  sendWord: '小鱼是云视频行业的领军企业，在这里有广阔的平台，完善的培养制度，还有导师一对一指导，帮助我们从学生向职场人迅速转变。期待有理想的你加入小鱼，在这里发挥无限的潜力！'
}, {
  img: '/campus/pc/senior_WangSiqing.png',
  name: '王思琴-蛟龙三期',
  from: '北京交通大学21届\r\r电子与通信工程专业',
  position: '产品部\r\r产品经理',
  sendWord: '小鱼是一家企业，更是一个大家庭。全面而专业的入职培训，一对一的导师指导，让我快速适应并融入，明确了自己前行的方向。在这里我们有共同目标，一起努力、学习、成长，充实而快乐！'
}];
var team = [{
  img: '/campus/pc/last-campus-05.jpg',
  title: '蛟龙一期团建'
}, {
  img: '/campus/pc/last-campus-01.jpg',
  title: '蛟龙一期培训'
}, {
  img: '/campus/pc/last-campus-02.jpg',
  title: '蛟龙二期团建'
}, {
  img: '/campus/pc/last-campus-03.jpg',
  title: '蛟龙二期培训'
}, {
  img: '/campus/pc/last-campus-06.jpg',
  title: '蛟龙三期团建'
}, {
  img: '/campus/pc/last-campus-07.jpg',
  title: '蛟龙三期培训'
}];

var Campus2022 = function Campus2022() {
  var size = (0,utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(components_campus_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    pageKey: "home",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner2),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: "\u60F3\u53C2\u4E0E\u8FD0\u8425\u5546\u7EA7\u4E13\u4E1A\u4E91\u5E73\u53F0\u7684\u8BBE\u8BA1\u4E0E\u5F00\u53D1\uFF1F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: "\u60F3\u6210\u4E3A\u53D7\u4EBA\u819C\u62DC\u4E1A\u754C\u9876\u5C16\u7684\u97F3\u89C6\u9891\u7B97\u6CD5\u5927\u725B\uFF1F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: "\u60F3\u4E86\u89E3\u5168\u7403\u90E8\u7F72\u7684\u89C6\u8BAF\u4E91\u67B6\u6784\u662F\u5982\u4F55\u642D\u5EFA\u7684\uFF1F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: 'for-pc',
          children: "\u60F3\u9009\u62E95G\u65F6\u4EE3\u4E0B\u6700\u5177\u6210\u957F\u529B\u7684\u4E91\u89C6\u9891\u72EC\u89D2\u517D\u4F01\u4E1A\u5F00\u7586\u62D3\u571F\uFF1F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("p", {
          className: 'for-mobile',
          children: ["\u60F3\u9009\u62E95G\u65F6\u4EE3\u4E0B\u6700\u5177\u6210\u957F\u529B\u7684\u4E91\u89C6\u9891\u72EC\u89D2\u517D\u4F01\u4E1A ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), "\u5F00\u7586\u62D3\u571F\uFF1F"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: 'for-pc',
          children: "\u8FD9\u4E00\u5207\u90FD\u4E0D\u518D\u9065\u4E0D\u53EF\u53CA\uFF0C\u73B0\u5728\u5C31\u8BF7\u5173\u6CE8\u5C0F\u9C7C\u6613\u8FDE\u201C\u86DF\u9F99\u8BA1\u52122022\u201D\uFF0C"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("p", {
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().start), 'for-mobile'),
          children: ["\u8FD9\u4E00\u5207\u90FD\u4E0D\u518D\u9065\u4E0D\u53EF\u53CA\uFF0C ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), "\u73B0\u5728\u5C31\u8BF7\u5173\u6CE8\u5C0F\u9C7C\u6613\u8FDE\u201C\u86DF\u9F99\u8BA1\u52122022\u201D\uFF0C"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("p", {
          className: 'for-mobile',
          children: ["\u9762\u5411\u5168\u56FD\u591A\u6240\u91CD\u70B9\u9662\u6821\u7684\u6821\u56ED\u62DB\u8058\u6D3B\u52A8 ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), "\u5DF2\u7ECF\u5168\u9762\u542F\u52A8\u5566\uFF01!"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: 'for-pc',
          children: "\u9762\u5411\u5168\u56FD\u591A\u6240\u91CD\u70B9\u9662\u6821\u7684\u6821\u56ED\u62DB\u8058\u6D3B\u52A8\u5DF2\u7ECF\u5168\u9762\u542F\u52A8\u5566\uFF01!"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: 'for-pc',
          children: "\u57F9\u80B2\u5343\u540D\u884C\u4E1A\u7CBE\u82F1\uFF0C\u53EA\u8981\u4F60\u80AF\u6765\uFF0C\u673A\u4F1A\u5C31\u5728\u4F60\u7684\u624B\u4E0A\uFF01"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("p", {
          className: 'for-mobile',
          children: ["\u57F9\u80B2\u5343\u540D\u884C\u4E1A\u7CBE\u82F1\uFF0C", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), "\u53EA\u8981\u4F60\u80AF\u6765\uFF0C\u673A\u4F1A\u5C31\u5728\u4F60\u7684\u624B\u4E0A\uFF01"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          href: "https://xylink.zhiye.com/campus",
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btn),
          children: "\u7ACB\u5373\u7533\u8BF7"
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner3),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: "\u5C0F\u9C7C\u6613\u8FDE\u662F\u4E00\u5BB6\u600E\u6837\u7684\u516C\u53F8\uFF1F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().desc),
          children: "\u5C0F\u9C7C\u6613\u8FDE\u662F\u4E2D\u56FD\u9886\u5148\u7684\u9AD8\u54C1\u8D28\u4E91\u89C6\u9891\u4E13\u5BB6\uFF0C\u62E5\u6709\u5927\u89C4\u6A21\u4E91\u8BA1\u7B97\u548C\u97F3\u89C6\u9891\u7684\u6838\u5FC3\u81EA\u4E3B\u77E5\u8BC6\u4EA7\u6743\uFF0C\u4EE5\u53CA\u5168\u573A\u666F\u89C6\u9891\u7EC8\u7AEF\uFF0C\u9762\u5411\u653F\u5E9C\u3001\u6559\u80B2\u3001\u533B\u7597\u7B49\u673A\u6784\u548C\u5404\u884C\u4E1A\u4F01\u4E1A\uFF0C\u63D0\u4F9B\u5168\u7F51\u7EDC\u73AF\u5883\u4E0B\u8D85\u9AD8\u6E05\u3001\u4F4E\u5EF6\u65F6\u3001\u5B89\u5168\u3001\u53EF\u9760\u7684\u4E00\u7AD9\u5F0F\u4E91\u89C6\u9891\u89E3\u51B3\u65B9\u6848\u3002\u5C0F\u9C7C\u6613\u8FDE\u76EE\u524D\u5DF2\u7ECF\u6DF1\u5165\u5230\u653F\u52A1\u3001\u6559\u80B2\u3001\u4FDD\u9669\u3001\u94F6\u884C\u3001\u533B\u7597\u3001\u5236\u9020\u3001\u77F3\u6CB9\u3001\u7535\u529B\u3001\u5EFA\u7B51\u3001\u9AD8\u79D1\u6280\u7535\u5B50\u7B49\u9886\u57DF\uFF0C\u670D\u52A1\u4E8E\u5341\u4E07\u591A\u5BB6\u5BA2\u6237\uFF0C\u5176\u4E2D\u5305\u62EC\u4E09\u5341\u591A\u5BB6\u4E2D\u592E\u4F01\u4E1A\u548C\u56FD\u5BB6\u90E8\u59D4\uFF0C\u4EE5\u53CA\u4E0A\u767E\u5BB6\u7701\u5E02\u653F\u5E9C\u673A\u6784\uFF0C\u662F\u201C\u65B0\u57FA\u5EFA\u4EA7\u4E1A\u72EC\u89D2\u517D\u3001\u4E91\u89C6\u9891\u4F1A\u8BAE\u884C\u4E1A\u9886\u519B\u4F01\u4E1A\u3001\u4E2D\u56FD\u79D1\u521B\u4F01\u4E1A\u767E\u5F3A\u3001\u667A\u6167\u53F8\u6CD5\u5341\u5927\u89E3\u51B3\u65B9\u6848\u63D0\u4F9B\u5546\u201D\uFF0C\u8FDE\u7EED\u4E24\u5E74\u5728\u4E2D\u56FD\u7F51\u7EDC\u4F1A\u8BAE\u5E02\u573A\u7684\u5360\u6709\u7387\u6392\u540D\u9996\u4F4D\u3002"
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner4),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: "\u4EC0\u4E48\u662F \u201C\u86DF\u9F99\u8BA1\u5212\u201D \uFF1F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: "\u201C\u86DF\u9F99\u8BA1\u5212\u201D\u662F\u5C0F\u9C7C\u6613\u8FDE\u63A8\u51FA\u7684\u9762\u5411\u9AD8\u6821\u5E94\u5C4A\u751F\u62DB\u8058\u7684\u7279\u6B8A\u4EBA\u624D\u57F9\u517B\u8BA1\u5212\uFF0C\u57F9\u80B2\u5343\u540D\u672A\u6765\u7684\u4E1A\u754C\u7CBE\u82F1\uFF01"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: "\u5165\u804C\uFF1A\u5185\u90E8\u5BFC\u5E08\u4E00\u5BF9\u4E00\u57F9\u517B\u4E0E\u804C\u4E1A\u89C4\u5212\u5236\u5B9A\uFF1B"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: "\u8F6C\u6B63\uFF1A\u53EF\u5728\u5BFC\u5E08\u6307\u5BFC\u4E0B\u81EA\u4E3B\u9009\u62E9\u5DE5\u4F5C\u5C97\u4F4D\uFF0C\u5E76\u53EF\u5728\u5317\u4EAC\u603B\u90E8\u53CA\u5404\u5730\u5206\u516C\u53F8\u5B9A\u671F\u8FDB\u884C\u4EA4\u6D41\u5B66\u4E60\uFF1B"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: "\u5DE5\u4F5C\u6EE1\u4E24\u5E74\uFF1A\u7ECF\u8FC7\u8003\u6838\u4E0E\u8BC4\u4F30\uFF0C\u53EF\u664B\u5347\u9AA8\u5E72\u6216\u7ECF\u7406\u804C\u7EA7\u3002"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: "\u86DF\u9F99\u8BA1\u5212\u5DF2\u5706\u6EE1\u5B8C\u6210\u4E09\u671F\u4EBA\u624D\u57F9\u517B\uFF0C\u86DF\u9F99\u56DB\u671F\u6B22\u8FCE\u60A8\u7684\u52A0\u5165\uFF01"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          href: "https://xylink.zhiye.com/campus",
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btn),
          children: "\u7ACB\u5373\u7533\u8BF7"
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner3), (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner5)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: "\u4F60\u80FD\u591F\u5728\u8FD9\u91CC\u83B7\u5F97\u4EC0\u4E48\uFF1F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().desc),
          children: "\u521A\u521A\u8D70\u51FA\u6821\u56ED\u7684\u5B66\u751F\uFF0C\u5C31\u50CF\u4E00\u5F20\u5145\u6EE1\u65E0\u9650\u9050\u60F3\u7684\u767D\u7EB8\uFF0C\u53EF\u4EE5\u753B\u51FA\u6700\u7F8E\u7684\u56FE\u753B\u3002\u4F60\u53EF\u80FD\u4E0D\u5177\u5907\u4E30\u5BCC\u7684\u5DE5\u4F5C\u7ECF\u9A8C\uFF0C\u4E5F\u7F3A\u5C11\u4E13\u4E1A\u7684\u77E5\u8BC6\u6280\u80FD\uFF0C\u4F46\u53EA\u8981\u4F60\u6709\u4FE1\u5FC3\u3001\u80AF\u52AA\u529B\u3001\u7231\u94BB\u7814\u3001\u6C42\u4E0A\u8FDB\uFF0C\u4F60\u5C31\u53EF\u4EE5\u6210\u4E3A\u5C0F\u9C7C\u7684\u4E00\u5458\uFF0C\u52A0\u5165\u5230\u5373\u5C06\u5230\u6765\u7684\u4E91\u89C6\u8BAF\u5927\u6F6E\u4E2D\uFF0C\u505A\u4E00\u540D\u6FC0\u6D41\u52C7\u8FDB\u7684\u51B2\u6D6A\u8005\u3002\u8FD9\u91CC\u6709\u97F3\u89C6\u9891\u4E13\u5BB6\u624B\u628A\u624B\u6307\u5BFC\uFF0C\u4E5F\u6709\u8D44\u6DF1\u67B6\u6784\u5E08\u968F\u65F6\u6C9F\u901A\u8BA8\u8BBA\uFF0C\u66F4\u6709\u4E13\u4E1A\u7684\u9500\u552E\u5927\u725B\u5F15\u8DEF\u5165\u95E8\u3002\u7B54\u7591\u89E3\u60D1\u540E\uFF0C\u5728\u5B9E\u9645\u7684\u4EA7\u54C1\u6216\u9879\u76EE\u4E2D\u52A8\u624B\u5B9E\u8DF5\uFF0C\u8BA9\u81EA\u5DF1\u5FEB\u901F\u6210\u957F\u3002"
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner4), (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner6)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: "\u5458\u5DE5\u798F\u5229"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().step),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().item),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
              src: "/v2/images/campus/airplane.png",
              alt: "",
              className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["item-icon"])
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
              src: "/v2/images/campus/line1.png",
              alt: "",
              className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().line), 'for-pc')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u4E94\u9669\u4E00\u91D1"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u5E26\u85AA\u4F11\u5047\u3001\u5E74\u5EA6\u4F53\u68C0"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().item),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
              src: "/v2/images/campus/rest.png",
              alt: "",
              className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["item-icon"])
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
              src: "/v2/images/campus/line2.png",
              alt: "",
              className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().line), 'for-pc')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u9910\u8865"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u4E0B\u5348\u8336\u3001\u6C34\u679C\u96F6\u98DF"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().item),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
              src: "/v2/images/campus/collect.png",
              alt: "",
              className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["item-icon"])
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
              src: "/v2/images/campus/line3.png",
              alt: "",
              className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().line), 'for-pc')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u7ED3\u5A5A\u3001\u751F\u5B50\u793C\u91D1"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u8282\u65E5\u798F\u5229"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().item),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
              src: "/v2/images/campus/sport.png",
              alt: "",
              className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["item-icon"])
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u5065\u8EAB\u6D3B\u52A8\u3001\u6E38\u6CF3"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u8DB3\u7403\u3001\u7BEE\u7403\u7B49\u4FF1\u4E50\u90E8"
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner3), (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner7)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: "\u516C\u53F8\u8363\u8A89"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().desc),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            children: "\u56FD\u9645\u6743\u5A01\u6570\u636E\u673A\u6784"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            children: "IDC\u6700\u65B0\u5E74\u5EA6\u62A5\u544A \u4E2D\u56FD\u7F51\u7EDC\u4F1A\u8BAE\u5E02\u573A\u5360\u6709\u7387\u7B2C\u4E00"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            children: "\u4E2D\u56FD\u4F01\u4E1A\u5BB6 \xA0\u4E2D\u56FD\u79D1\u521B\u4F01\u4E1A\u767E\u5F3A"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            children: "36Kr \xA02020\u6700\u4F73\u534F\u540C\u529E\u516C\u89E3\u51B3\u65B9\u6848\u5956"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            children: "i\u9ED1\u9A6C \xA02020\u201C\u65B0\u57FA\u5EFA\u201D\u4EA7\u4E1A\u72EC\u89D2\u517DTOP100"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            children: "Gartner \xA02019 Cool Vendors"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            children: "......"
          })]
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner4), (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner8)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title), 'for-pc'),
          children: "\u5DE5\u4F5C\u73AF\u5883"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title), 'for-mobile'),
          children: "\u529E\u516C\u73AF\u5883"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd_lib_carousel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          autoplay: true,
          dots: false,
          slidesToShow: size.width > 767 ? 2 : 1,
          slidesToScroll: 1,
          children: environmentList.map(function (item) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
              className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["environment-item"]),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                src: IMG_PATH + item.img,
                alt: ""
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                children: item.title
              })]
            }, item.title);
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner3), (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner9)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: "\u201C\u86DF\u9F99\u8BA1\u5212\u201D\u5B66\u5458\u8BF4"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd_lib_carousel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          autoplay: true,
          dots: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          className: 'for-pc',
          children: seniorList.map(function (item) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
              className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["senior-item"]),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                src: IMG_PATH + item.img,
                alt: ""
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().introduce),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                  className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().name),
                  children: item.name
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                  className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().from),
                  dangerouslySetInnerHTML: {
                    __html: item.from.replace(/\r/g, '&nbsp;')
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                  className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().from),
                  dangerouslySetInnerHTML: {
                    __html: item.position.replace(/\r/g, '&nbsp;')
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                  className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sendWord),
                  children: item.sendWord
                })]
              })]
            }, item.name);
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: 'for-mobile',
          children: seniorList.map(function (item) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
              className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["senior-item"]),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                src: IMG_PATH + item.img,
                alt: ""
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().introduce),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                  className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().name),
                  children: item.name
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                  className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().from),
                  dangerouslySetInnerHTML: {
                    __html: item.from.replace(/\r/g, '&nbsp;')
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                  className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().position),
                  dangerouslySetInnerHTML: {
                    __html: item.position.replace(/\r/g, '&nbsp;')
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                  className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sendWord),
                  children: item.sendWord
                })]
              })]
            }, item.name);
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner4), (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner8)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: "\u201C\u86DF\u9F99\u8BA1\u5212\u201D\u5B66\u5458\u98CE\u91C7"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd_lib_carousel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          autoplay: true,
          dots: false,
          slidesToShow: size.width > 767 ? 2 : 1,
          slidesToScroll: 1,
          children: team.map(function (item) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
              className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["environment-item"]),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                src: IMG_PATH + item.img,
                alt: ""
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                children: item.title
              })]
            }, item.title);
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner3), (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().banner10)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: "\u7533\u8BF7\u804C\u4F4D"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: "\u7533\u8BF7\u804C\u4F4D\u65F6\u9700\u6DFB\u52A0\u7B80\u5386\u9644\u4EF6"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: "\u7B80\u5386\u6807\u9898\u683C\u5F0F\uFF1A\u671F\u671B\u5DE5\u4F5C\u5730+\u59D3\u540D+\u804C\u4F4D\uFF0C\u5982: \u201C\u6210\u90FD+\u738B\u6653\u745C+Java\u5F00\u53D1\u5DE5\u7A0B\u5E08\u201D"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnS),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            href: "https://xylink.zhiye.com/campus",
            className: (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btn),
            children: "\u7ACB\u5373\u7533\u8BF7"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            href: "/",
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btn), (styles_campus_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().goHome)),
            children: "\u8BBF\u95EE\u5C0F\u9C7C\u5B98\u7F51\u9996\u9875"
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Campus2022);

/***/ }),

/***/ 94142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var UseResize = function UseResize() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: 0
  }),
      size = _useState[0],
      setSize = _useState[1];

  var onResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setSize({
      width: document.documentElement.clientWidth
    });
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    onResize();
  }, [onResize]);
  return size;
};

/* harmony default export */ __webpack_exports__["Z"] = (UseResize);

/***/ }),

/***/ 41240:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _typeof = __webpack_require__(50008);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(59713));

var _extends2 = _interopRequireDefault(__webpack_require__(67154));

var React = _interopRequireWildcard(__webpack_require__(67294));

var _reactSlick = _interopRequireDefault(__webpack_require__(77602));

var _classnames = _interopRequireDefault(__webpack_require__(94184));

var _configProvider = __webpack_require__(48146);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Carousel = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _classNames;

  var _a$dots = _a.dots,
      dots = _a$dots === void 0 ? true : _a$dots,
      _a$arrows = _a.arrows,
      arrows = _a$arrows === void 0 ? false : _a$arrows,
      _a$draggable = _a.draggable,
      draggable = _a$draggable === void 0 ? false : _a$draggable,
      _a$dotPosition = _a.dotPosition,
      dotPosition = _a$dotPosition === void 0 ? 'bottom' : _a$dotPosition,
      props = __rest(_a, ["dots", "arrows", "draggable", "dotPosition"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var slickRef = React.useRef();

  var goTo = function goTo(slide) {
    var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    slickRef.current.slickGoTo(slide, dontAnimate);
  };

  React.useImperativeHandle(ref, function () {
    return {
      goTo: goTo,
      autoPlay: slickRef.current.innerSlider.autoPlay,
      innerSlider: slickRef.current.innerSlider,
      prev: slickRef.current.slickPrev,
      next: slickRef.current.slickNext
    };
  }, [slickRef.current]);
  var prevCount = React.useRef(React.Children.count(props.children));
  React.useEffect(function () {
    if (prevCount.current !== React.Children.count(props.children)) {
      goTo(props.initialSlide || 0, false);
      prevCount.current = React.Children.count(props.children);
    }
  }, [props.children]);
  var newProps = (0, _extends2["default"])({}, props);

  if (newProps.effect === 'fade') {
    newProps.fade = true;
  }

  var prefixCls = getPrefixCls('carousel', newProps.prefixCls);
  var dotsClass = 'slick-dots';
  newProps.vertical = dotPosition === 'left' || dotPosition === 'right';
  var enableDots = !!dots;
  var dsClass = (0, _classnames["default"])(dotsClass, "".concat(dotsClass, "-").concat(dotPosition), typeof dots === 'boolean' ? false : dots === null || dots === void 0 ? void 0 : dots.className);
  var className = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-vertical"), newProps.vertical), _classNames));
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(_reactSlick["default"], (0, _extends2["default"])({
    ref: slickRef
  }, newProps, {
    dots: enableDots,
    dotsClass: dsClass,
    arrows: arrows,
    draggable: draggable
  })));
});
var _default = Carousel;
exports.Z = _default;

/***/ }),

/***/ 79445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


__webpack_require__(92667);

__webpack_require__(33177);

/***/ }),

/***/ 95840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campus2022",
      function () {
        return __webpack_require__(16267);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33177:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 34769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"campus_border__px__J_nV5","border__px-before":"campus_border__px-before__I8XIv","border__px-before1":"campus_border__px-before1__ZvO_W","border-children1":"campus_border-children1__Ih3ML","border-children2":"campus_border-children2__mwgQO","for-mobile":"campus_for-mobile__xrU0J","for-pc":"campus_for-pc__uqukq","layout":"campus_layout__PtVlT","layout-header":"campus_layout-header__cAmaN","header":"campus_header__NmPlm","container":"campus_container__h4QTV","banner":"campus_banner__ceyyI","nav-parent":"campus_nav-parent__OL5o_","navbar":"campus_navbar__Nbfty","navItem":"campus_navItem__dWa__","focus":"campus_focus__OpJuA","fixed":"campus_fixed__fAcTa","place":"campus_place__9xUFE"};

/***/ }),

/***/ 78722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"openApp_border__px__FmGOd","border__px-before":"openApp_border__px-before__Qupc7","border__px-before1":"openApp_border__px-before1__CuTDy","border-children1":"openApp_border-children1__CImVx","border-children2":"openApp_border-children2__Emeif","for-mobile":"openApp_for-mobile__nYIME","for-pc":"openApp_for-pc__wvcMn","download-app-tips":"openApp_download-app-tips__6g_lZ","hide":"openApp_hide__Y9UtC","left":"openApp_left__fflJR","btn-delete":"openApp_btn-delete__o_Nq0","icon-xiaoyu":"openApp_icon-xiaoyu__F_VQu","main-title":"openApp_main-title__83pW2","header-title":"openApp_header-title__eT9NG","header-desc":"openApp_header-desc__AomhT","right":"openApp_right__n9_F0","open-app":"openApp_open-app__lBSUM"};

/***/ }),

/***/ 70036:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"campus_border__px__XAYyR","border__px-before":"campus_border__px-before__F6qDd","border__px-before1":"campus_border__px-before1__A1Rpk","border-children1":"campus_border-children1__lNSJO","border-children2":"campus_border-children2__VgvO7","for-mobile":"campus_for-mobile__XTpIG","for-pc":"campus_for-pc__PT4WD","btn":"campus_btn__6S9BD","banner2":"campus_banner2__JODFf","content":"campus_content__p3KRM","banner3":"campus_banner3__66Te8","title":"campus_title___GZA3","desc":"campus_desc__fdl1P","banner4":"campus_banner4__zr8OY","banner5":"campus_banner5__XwKpg","banner6":"campus_banner6__DW_Et","step":"campus_step__SY_nJ","item":"campus_item__d3B_f","item-icon":"campus_item-icon__3APSi","line":"campus_line__REvc8","banner7":"campus_banner7__i9yRZ","banner8":"campus_banner8__71YQZ","environment-item":"campus_environment-item__a7428","banner9":"campus_banner9__bfzKt","senior-item":"campus_senior-item__VdOJ_","name":"campus_name__Cvot4","from":"campus_from__PZRcO","position":"campus_position__JTynk","sendWord":"campus_sendWord__Zuvhx","banner10":"campus_banner10__VyCTf","btnS":"campus_btnS__i_GJ1","goHome":"campus_goHome__dKyJB","start":"campus_start___Iqd5","introduce":"campus_introduce__4Vwm3"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1747,7602,9774,2888,179], function() { return __webpack_exec__(95840); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);